export const formatPhoneNumber = (phoneNumber: string) => {
  const phone = phoneNumber.replace(/\D/g, "").slice(0, 10);
  if (phone.length >= 7) {
    return `(${phone.slice(0, 3)})${phone.slice(3, 6)}-${phone.slice(6)}`;
  } else if (phone.length >= 4) {
    return `(${phone.slice(0, 3)})${phone.slice(3)}`;
  }
  return phone;
};

export const formatBirthDate = (birthday: string) => {
  const birtDate = birthday.replace(/\D/g, "").slice(0, 8);
  if (birtDate.length >= 5) {
    return `${birtDate.slice(0, 2)}/${birtDate.slice(2, 4)}/${birtDate.slice(4)}`;
  } else if (birtDate.length >= 3) {
    return `${birtDate.slice(0, 2)}/${birtDate.slice(2)}`;
  }
  return birtDate;
};
